module.exports = __webpack_public_path__ + "img/playback.63798f90.png";